module.exports = __webpack_public_path__ + "static/banner-bb68e09451f032526bbadf6f5c776e44.png";